import axios from '../utils/axios.wrapper'

const TOKEN_KEY = "accessToken";
const REFRESH_KEY = "refreshToken";
const EXPIRES_KEY = "expiresAt";

const setTokens = ({ accessToken, refreshToken, expiresIn }) => {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(REFRESH_KEY, refreshToken);
  localStorage.setItem(EXPIRES_KEY, String(Date.now() + expiresIn * 1000));
};

const clearTokens = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(EXPIRES_KEY);
};

const getAccessToken = () => localStorage.getItem(TOKEN_KEY);
const getRefreshToken = () => localStorage.getItem(REFRESH_KEY);
const getExpiry = () => Number(localStorage.getItem(EXPIRES_KEY));

export const isTokenExpired = () => {
  const expiry = getExpiry();
  if (!expiry) return true;
  return Date.now() >= expiry;
};

export const isAuthenticationValid = () => {
  if (!getAccessToken()) return false;
  // Disabled until expires at is fixed
  /**
   * @TODO Fix expires in backend
   */
  // return !(isTokenExpired())
  return true
}

export const login = async (credentials) => {
  const { data } = await axios.post("/auth/login", credentials);
  setTokens(data);
  return data;
};

export const refreshAuthToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    clearTokens();
    throw new Error("No refresh token");
  }
  try {
    const { data } = await axios.post("/auth/refresh", { refreshToken });
    setTokens(data);
    return data;
  } catch (error) {
    // If refresh fails (expired refresh token or other error), clear tokens and redirect
    clearTokens();
    // Don't throw error to avoid infinite loop
    window.location.href = "/signin";
    return Promise.reject(error);
  }
};

export const getCurrentUser = async () => {
  const { data } = await axios.get("/user/me");
  return data;
};

export const logout = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new Error("No refresh token");
  await axios.post("/auth/logout", { refreshToken });

  clearTokens();
  //window.location.href = "/signin";
};

export const authService = {
  login,
  refreshAuthToken,
  logout,
  getCurrentUser,
  getAccessToken,
  getRefreshToken,
  getExpiry,
};